import { type Revision, RevisionPageType } from '../types';

/**
 * Get the containers that have been modified between the two revisions.
 * A container here refers to a page or a reusable content ID. It is considered modified
 * if the document for the container has changed.
 */
export function getModifiedDocumentContainers({
    current,
    previous,
}: {
    current: Revision;
    previous: Revision | null;
}) {
    if (!previous) {
        return [];
    }

    const containerIds: string[] = [];

    Object.entries(current.pages).forEach(([key, currPage]) => {
        if (currPage.type === RevisionPageType.Document) {
            const prevPage = previous.pages[key];
            if (
                prevPage &&
                prevPage.type === RevisionPageType.Document &&
                currPage.document !== prevPage.document
            ) {
                containerIds.push(key);
            }
        }
    });

    Object.entries(current.reusableContents).forEach(([key, currRuc]) => {
        const prevRuc = previous.reusableContents[key];
        if (prevRuc && currRuc.document !== prevRuc.document) {
            containerIds.push(key);
        }
    });

    return containerIds;
}
